import axios from "axios";
import { FETCH_SOCIAL_MEDIA_SUBMISSION, FETCH_SOCIAL_MEDIA_WINNERS, interceptor } from ".";
import store from "../store";

interceptor(axios, store);

export function fetchSocialMediaSubmissions() {
  return {
    type: FETCH_SOCIAL_MEDIA_SUBMISSION,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/socialmedia/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

export function fetchSocialWinners() {
  return {
    type: FETCH_SOCIAL_MEDIA_WINNERS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/socialmedia/winners`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}
